module.exports = __webpack_public_path__ + "static/media/pt.67bf8f9e.png";